const map = document.querySelector('#map-brazil')
const address = document.querySelector('#mapa #address')

const ufs = map.querySelectorAll('.uf')

ufs.forEach((uf) => {
  uf.addEventListener('mouseover', () => {
    uf.classList.add('hover')
  })
  uf.addEventListener('mouseout', () => {
    if (!uf.classList.contains('active')) {
      uf.classList.remove('hover')
    }
  })
  uf.addEventListener('click', () => {
    // quit if disabled
    if (uf.classList.contains('disabled')) {
      return
    }
    // hidden all address
    address.querySelectorAll('div').forEach((div) => {
      div.style.display = 'none'
    })
    // remove active class to all ufs
    ufs.forEach((uf) => {
      uf.classList.remove('hover')
      uf.classList.remove('active')
    })
    // add active class to map and show current address
    uf.classList.add('active')
    address.querySelector(`#${uf.getAttribute('id')}`).style.display = 'block'
  })
})
